import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { MonitoringOverview } from '../types/monitoring';

export function useMonitoringOverview() {
  return useQuery({
    queryKey: ['monitoring', 'overview'],
    queryFn: async () => {
      return apiClient.get<MonitoringOverview>('/monitoring/metrics');
    },
    refetchInterval: 15000,
    staleTime: 10000,
    retry: 1,
  });
}
